import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import {
  exportInputValuesCompletedModalClose,
  exportInputValuesFailure,
  exportInputValuesFailureModalClose,
  exportInputValuesInitialize,
  exportInputValuesModalClose,
  exportInputValuesModalMinimize,
  exportInputValuesModalOpen,
  exportInputValuesProgressModalClose,
  exportInputValuesStart,
  exportInputValuesSuccess,
} from './actions';

export interface ExportInputValuesState {
  exportTargetIds: string[];
  exportTargetResource: 'DOCUMENTS' | 'BULK_REQUEST' | 'CONTRACT_LINK' | 'LABEL';
  errorMessage: string | null;
  failureCount: number;
  isModalMinimized: boolean;
  jobId: string | null;
  requesterInput: boolean;
  status: ExportInputValuesStatus;
  successCount: number;
  totalCount: number;
  url: string | null;
}

export type ExportInputValuesStatus =
  | 'IDLE'
  | 'READY'
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED';

const initialState: ExportInputValuesState = {
  exportTargetIds: [],
  exportTargetResource: 'DOCUMENTS',
  errorMessage: null,
  failureCount: 0,
  isModalMinimized: false,
  jobId: null,
  requesterInput: true,
  status: 'IDLE',
  successCount: 0,
  totalCount: 0,
  url: null,
};

export const { reducer } = createSlice({
  name: 'exportInputValues',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(exportInputValuesModalOpen, (state, action) => ({
      ...initialState,
      exportTargetResource: action.payload.exportTargetResource,
      exportTargetIds: action.payload.exportTargetIds,
      status: 'READY',
    }));
    builder.addCase(exportInputValuesModalMinimize, (state, action) => {
      state.isModalMinimized = action.payload.isMinimized;
    });
    builder.addCase(exportInputValuesStart, (state, action) => {
      const { jobId } = action.payload;
      state.jobId = jobId;
      state.status = 'IN_PROGRESS';
    });
    builder.addCase(exportInputValuesSuccess, (state, action) => {
      const { failureCount, successCount, totalCount, url } = action.payload;
      state.status = 'COMPLETED';
      state.failureCount = failureCount;
      state.successCount = successCount;
      state.totalCount = totalCount;
      state.url = url;
    });
    builder.addCase(exportInputValuesFailure, (state, action) => {
      const { errorMessage, failureCount, successCount, totalCount, url } = action.payload;
      state.status = 'FAILED';
      state.errorMessage = errorMessage;
      state.failureCount = failureCount;
      state.successCount = successCount;
      state.totalCount = totalCount;
      state.url = url;
    });
    builder.addMatcher(
      isAnyOf(
        exportInputValuesInitialize,
        exportInputValuesModalClose,
        exportInputValuesCompletedModalClose,
        exportInputValuesFailureModalClose,
        exportInputValuesProgressModalClose
      ),
      () => initialState
    );
  },
});
